// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"398":"Faqs","438":"Login","639":"Resume","913":"Logout"}[chunkId] + "." + {"398":"0c47cda5","438":"6e6c8693","639":"1888ac82","913":"8ae96f51"}[chunkId] + ".js";
};